module.exports = __webpack_public_path__ + "static/media/addIconLightBlue.6d327a68.svg";